import { useEffect, useState } from 'react';
import { sectionNav } from '@/mocks/mikami/sections';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-gradient-to-b from-foreground-950/50 to-transparent'
      }`}
    >
      <nav className="flex h-16 items-center justify-between gap-4 px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-base font-bold tracking-wide md:text-lg ${
              solid ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            三上悠亚电影
          </span>
        </a>

        <ul className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {sectionNav.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-label transition-colors ${
                  solid
                    ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                    : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#films"
          className="hidden shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 lg:inline-flex"
        >
          <i className="ri-play-list-2-line"></i>
          浏览新片
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开导航菜单"
          aria-expanded={open}
          className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md transition-colors lg:hidden ${
            solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/15'
          }`}
        >
          <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <ul className="grid grid-cols-2 gap-2">
            {sectionNav.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="block cursor-pointer rounded-md bg-background-100 px-3 py-2.5 text-sm font-label text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#films"
            onClick={() => setOpen(false)}
            className="mt-3 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-list-2-line"></i>
            浏览新片速览
          </a>
        </div>
      )}
    </header>
  );
}